export const formatDaysOfWeek = (daysString) => {
    if (!daysString || typeof daysString !== 'string' || daysString.trim() === '') {
        return '';
    }

    const dayNames = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

    const days = daysString.split(',')
        .map(day => day.trim())
        .filter(day => day !== '')
        .map(day => parseInt(day, 10))
        .filter(day => day >= 1 && day <= 7)
        .sort((a, b) => a - b);

    const uniqueDays = [...new Set(days)];
    const formattedDays = uniqueDays.map(day => dayNames[day - 1]);

    return formattedDays.join(', ');
};


export const formatMonths = (monthsString) => {
    if (!monthsString && monthsString !== 0) {
        return '';
    }
    const monthInt = parseInt(monthsString, 10);
    if (isNaN(monthInt) || monthInt < 1 || monthInt > 12) {
        return monthsString || '';
    }
    const monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
    return monthNames[monthInt - 1];
};